import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 20 20',
    fill: 'currentColor',
    defaultAriaLabel: 'Arrow Down Icon',
};

export const ArrowDownIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.8142 14.4628L15.1426 10.1343C15.4606 9.81634 15.9762 9.81634 16.2942 10.1343C16.6122 10.4523 16.6122 10.9679 16.2942 11.2859L10.5758 17.0044C10.4231 17.1571 10.216 17.2429 10 17.2429C9.78407 17.2429 9.57695 17.1571 9.42424 17.0044L3.70579 11.2859C3.38779 10.9679 3.38779 10.4523 3.70579 10.1343C4.02379 9.81634 4.53937 9.81634 4.85737 10.1343L9.18566 14.4626L9.18566 3.5714C9.18566 3.12168 9.55023 2.75711 9.99995 2.75711C10.4497 2.75711 10.8142 3.12168 10.8142 3.5714L10.8142 14.4628Z"
            />
        </SvgIcon>
    );
};
